import { render, staticRenderFns } from "./GlobalInfoBar.vue?vue&type=template&id=5907ec66&scoped=true"
import script from "./GlobalInfoBar.vue?vue&type=script&lang=js"
export * from "./GlobalInfoBar.vue?vue&type=script&lang=js"
import style0 from "./GlobalInfoBar.vue?vue&type=style&index=0&id=5907ec66&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5907ec66",
  null
  
)

export default component.exports